export default __webpack_public_path__ + "static/image-10-7d779fff64465bc5af264c645507300d.jpg";